import Select from "react-select";

export interface SelectOption {
  label: string;
  value: string;
  isDisabled?: boolean;
}

interface BaseSelectProps {
  options?: SelectOption[];
  value?: SelectOption | null;
  onChange: (value: string) => void;
  placeholder?: string;
  menuPortalTarget?: HTMLElement | null;
  isLoading?: boolean;
  error?: string;
  width?: string | number;
  placeholderColor?: string;
}

export function BaseSelect({
  options = [],
  value,
  onChange,
  placeholder = "Selecione",
  isLoading,
  error,
  menuPortalTarget,
  width,
  placeholderColor = "#ccc",
}: BaseSelectProps) {
  const defaultOption: SelectOption = {
    label: placeholder,
    value: "",
    isDisabled: true,
  };

  const mergedOptions = [defaultOption, ...options];

  const selectedValue = value ?? defaultOption;

  return (
    <Select
      options={mergedOptions}
      value={selectedValue}
      isLoading={isLoading}
      isClearable={false}
      isSearchable
      menuPortalTarget={menuPortalTarget ?? document.body}
      menuPosition="fixed"
      placeholder={placeholder}
      onChange={(newValue) => onChange(newValue?.value || "")}
      className="text-sm"
      styles={{
        container: (base) => ({
          ...base,
          ...(width ? { width } : {}),
        }),
        menuPortal: (base) => ({ ...base, zIndex: 99999 }),
        menu: (base) => ({ ...base, zIndex: 99999 }),
        control: (base, state) => ({
          ...base,
          borderRadius: 30,
          borderColor: error ? "#f87171" : "#3B7F9F",
          boxShadow: state.isFocused
            ? `0 0 0 2px ${error ? "#f87171" : "#3B7F9F"}`
            : "none",
          "&:hover": {
            borderColor: error ? "#f87171" : "#3B7F9F",
          },
          minHeight: 36,
          height: 30,
        }),
        placeholder: (base) => ({
          ...base,
          color: placeholderColor,
        }),
        singleValue: (base, { data }) => ({
          ...base,
          color: (data as SelectOption).value === "" ? placeholderColor : base.color,
        }),
      }}
    />
  );
}
